import { render, staticRenderFns } from "./VircosTasksWidget.vue?vue&type=template&id=4369638e&scoped=true&"
import script from "./VircosTasksWidget.vue?vue&type=script&lang=js&"
export * from "./VircosTasksWidget.vue?vue&type=script&lang=js&"
import style0 from "./VircosTasksWidget.vue?vue&type=style&index=0&id=4369638e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4369638e",
  null
  
)

export default component.exports